import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  FetchEmbedZohoActions as Actions,
  FetchEmbedZohoRequestAction as RequestAction,
} from 'store/ducks/zohoDashboard';

export function* fetchZohoEmbedUrlRequest(action: any) {
  const { workspace, view, onSuccess, onFailure }: RequestAction = action;
  console.log('fetchZohoEmbedUrlRequest', { workspace, view, action });
  try {
    const { data } = yield call(api.get, `zoho-embed/${workspace}/${view}`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
